export interface MyTundraSiteParams {
  contentId?: string;
  entityNumber?: string;
}

export const buildMyTundraPath = (site?: MyTundraSiteParams): string => {
  if (!site?.entityNumber && !site?.contentId) {
    return '/my-tundra';
  }
  const params = new URLSearchParams();
  if (site.entityNumber) {
    params.set('rn', site.entityNumber);
  }
  if (site.contentId) {
    params.set('contentId', site.contentId);
  }
  return `/my-tundra?${params.toString()}`;
};

export const parseMyTundraSiteFromSearch = (search: string): MyTundraSiteParams | null => {
  const params = new URLSearchParams(search);
  const entityNumber = params.get('rn') || params.get('entityNumber') || undefined;
  const contentId = params.get('contentId') || undefined;
  if (!entityNumber && !contentId) {
    return null;
  }
  return { entityNumber, contentId };
};

export const siteParamsKey = (site: MyTundraSiteParams): string =>
  `${site.contentId || ''}|${site.entityNumber || ''}`;
